// import React, { Component } from "react";
// import { Switch, Route, Redirect, withRouter } from "react-router-dom";
// import { connect } from "react-redux";


// import "primereact/resources/themes/mdc-light-indigo/theme.css";
// import "primereact/resources/primereact.min.css";
// import "./styles/index.scss";

// import POSTopbar from "./Layout/POSTopbar";
// import POSSidebar, { ORDERactionTYPES ,NAV_PAGES, } from "./Layout/POSSidebar";
// import POSFooter from "./Layout/POSFooter";

// import Dashboard from "./Containers/Dashboard/Dashboard";
// import OrderManagement from "./Containers/Orders/OrderManagement";
// import OrderList from "./Containers/OrderList/OrderList";

// import * as actions from "../store/actions";
// import Messages from "../shared/UI/Messages/Messages";

// class POSApp extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       staticMenuInactive: false,
//       mobileMenuActive: false,
//       activeOrderType: ORDER_TYPES.DINE_IN,
//       activePage: NAV_PAGES.DASHBOARD, 
//     };
//   }

//   menuClick = false;

//   componentDidMount() {
//     this.props.onTryAuthSignUp();
//   }

//   onWrapperClick = () => {
//     if (!this.menuClick) {
//       this.setState({
//         mobileMenuActive: false,
//       });
//     }
//     this.menuClick = false;
//   };

//   onToggleMenu = (e) => {
//     this.menuClick = true;

//     if (window.innerWidth > 1024) {
//       this.setState((prev) => ({
//         staticMenuInactive: !prev.staticMenuInactive,
//       }));
//     } else {
//       this.setState((prev) => ({
//         mobileMenuActive: !prev.mobileMenuActive,
//       }));
//     }

//     e.preventDefault();
//   };

//   onSidebarClick = () => {
//     this.menuClick = true;
//   };

//   handleSelectOrderType = (type) => {
//     this.setState({
//       activeOrderType: type,
//     });
//   };
//   handleSelectPage = (page) => {
//   this.setState({ activePage: page });
//   // if these should also navigate, do it here, e.g.:
//   // this.props.history.push(`/pos/${page}`);
// };

//   render() {
//     if (this.props.loading) {
//       return <div className="page-loader"></div>;
//     }

//     if (!this.props.isAuthenticated) {
//       return <Redirect to="/" />;
//     }

//     return (
//       <>
//         {this.props.error && (
//           <Messages type="error" message={this.props.error} />
//         )}

//         <div className="pos-wrapper" onClick={this.onWrapperClick}>
//           <POSTopbar
//             onToggleMenu={this.onToggleMenu}
//             userDetail={this.props.userDetail}
//           />

//           <div className="pos-body">
//             <div
//               className="pos-sidebar-container"
//               onClick={this.onSidebarClick}
//             >
//               <POSSidebar
//                 collapsed={this.state.staticMenuInactive}
//                 activeOrderType={this.state.activeOrderType}
//                 onSelectOrderType={this.handleSelectOrderType}
//                 activePage={this.state.activePage}
//                 onSelectPage={this.handleSelectPage}
//                 />
//             </div>

//             <div className="pos-main">
//               <Switch>
//                 <Route path="/pos/dashboard" exact component={Dashboard} />

//                 <Route
//                   path="/pos/"
//                   exact
//                   render={() => (
//                     <OrderManagement
//                       activeOrderType={this.state.activeOrderType}
//                     />
//                   )}
//                 />

//                 <Route path="/pos/orderlist" exact component={OrderList} />

//                 <Redirect to="/pos" />
//               </Switch>
//             </div>
//           </div>

//           <POSFooter />
//         </div>
//       </>
//     );
//   }
// }

// const mapStateToProps = (state) => ({
//   isAuthenticated: state.auth.token !== null,
//   userDetail: state.auth.userDetail,
//   loading: state.auth.loading,
//   error: state.auth.error,
// });

// const mapDispatchToProps = (dispatch) => ({
//   onTryAuthSignUp: () => dispatch(actions.authCheckState()),
// });

// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(POSApp));


import React, { Component } from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import "primereact/resources/themes/mdc-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "./styles/index.scss";
import "primeicons/primeicons.css";

import { GUEST_HOME_PATH, IS_GUEST_SESSION, LOGIN_PATH } from "../shared/utility";
import POSTopbar from "./Layout/POSTopbar";
import POSSidebar, { ORDER_TYPES } from "./Layout/POSSidebar";
import POSFooter from "./Layout/POSFooter";
import Logout from "./Logout";

import LocationGate from "./Containers/Auth/LocationGate";
import QrGuestGate from "./Containers/Auth/QrGuestGate";
import Dashboard from "./Containers/Dashboard/Dashboard";
// import OrderManagement from "./Containers/Orders/OrderManagement";
import RestaurantOrder from './Containers/Orders/RestaurantOrder';
import OrderList from "./Containers/OrderList/OrderList";
import Reports from "./Containers/Reports/Reports";
import ProductionPlanReport from "./Containers/Reports/ProductionPlanReport";
// import OnlineConfig from "./Containers/OnlineConfig/OnlineConfig";
// import DayClose from "./Containers/DayClose/DayClose";
import KOTDashboard from "./Containers/KOTDashboard/KOTDashboard";
import PackingDashboard from "./Containers/PackingDashboard/PackingDashboard";
import Waiter from "./Containers/Waiter/Waiter";
import TableReservation from "./Containers/TableReservation/TableReservation";
import CaptainDashboard from "./Containers/CaptainDashboard/CaptainDashboard";
import PrintJobs from "./Containers/PrintJobs/PrintJobs";
import PettyCash from "./Containers/PettyCash/PettyCash";
import QrOrderlist from "./Containers/Orders/QrOrderlist";
import QrOrderDetails from "./Containers/Orders/QrOrderDetails";
import SpecialOrderDetails from "./Containers/Orders/SpecialOrderDetails";
import SoldOut from "./Containers/SoldOut/SoldOut";
import SignalRTest from "./Containers/SignalRTest/SignalRTest"; // TEMPORARY: SignalR test page
import "./realtime/notifyBridge"; // TEMPORARY: tells the realtime hub about saves until the main backend does
// import RestaurantOrder from "./Containers/Orders/RestaurantOrder";


import * as actions from "../store/actions";
import { POS_GUEST_SESSION_KEY } from "../shared/Config";
import Messages from "../shared/UI/Messages/Messages";
import TableReservationList from "./Containers/TableReservation/TableReservationList";
// Remembers the sidebar's last-picked order type across a manual page refresh
// (see handleSelectOrderType/constructor below). Switching itself doesn't
// reload the page — RestaurantOrder clears its own state in response to the
// activeOrderType prop change instead (see its componentDidUpdate).
const ORDER_TYPE_STORAGE_KEY = 'pos_activeOrderType';

// Pages that sign themselves in as the guest account when no staff session
// exists (OrderList.js, ProductionPlanReport.js), so they have to be allowed
// to mount before any login redirect can bounce them to "/".
const GUEST_CAPABLE_PATHS = ["/pos/orderlist", "/pos/productionplanreport"];

// Mirrors authCheckState: a token only counts while it is unexpired.
const hasLiveSession = () => {
  if (!localStorage.getItem("token")) return false;
  return new Date(localStorage.getItem("expirationDate")) > new Date();
};

class POSApp extends Component {
  constructor(props) {
    super(props);

    const savedOrderType = localStorage.getItem(ORDER_TYPE_STORAGE_KEY);
    const activeOrderType = Object.values(ORDER_TYPES).includes(savedOrderType)
      ? savedOrderType
      : ORDER_TYPES.DINE_IN;

    this.state = {
      staticMenuInactive: false,
      mobileMenuActive: false,
      activeOrderType,
    };
  }

  menuClick = false;

  componentDidMount() {
    // QR order paths own their own identity via QrGuestGate — running the
    // staff authCheckState here too would log out a brand-new customer
    // device (no token in localStorage yet) before QrGuestGate gets a
    // chance to bootstrap a guest session. Special Order paths bootstrap
    // their own guest session the same way (see SpecialOrderDetails.js).
    // Guest-capable pages with no live session are about to sign in as guest
    // too; authCheckState would find no token and dispatch logout(), whose
    // localStorage.clear() can wipe that guest token while the login is still
    // in flight. With a live session (staff, or a returning guest) it runs as
    // normal, which is what populates userDetail for those pages.
    const guestBootstrapping = this.isGuestCapablePath() && !hasLiveSession();
    if (!this.isQrOrderPath() && !this.isSpecialOrderPath() && !guestBootstrapping) {
      this.props.onTryAuthSignUp();
    }
    this.syncBodyScrollLock();
  }

  componentDidUpdate() {
    this.syncBodyScrollLock();
  }

  componentWillUnmount() {
    document.body.classList.remove('pos-active');
  }

  // Pins the document to the viewport for the staff shell (topbar/sidebar/
  // .pos-main) via body.pos-active — see _layout.scss — so .pos-main ends up
  // the only scrollable element instead of the whole page also scrolling.
  // Left off for the QR customer flow, which isn't wrapped in .pos-wrapper
  // and scrolls normally on the customer's own device.
  syncBodyScrollLock = () => {
    const usesShell = this.props.isAuthenticated && !this.isQrOrderPath() && !this.isSpecialOrderPath()
      && !this.rendersGuestStandalone();
    document.body.classList.toggle('pos-active', usesShell);
  };

  isQrOrderPath = () => {
    const { pathname } = this.props.location;
    return pathname === "/pos/qrorder" || pathname.startsWith("/pos/qrorder/");
  };

  isSpecialOrderPath = () => {
    const { pathname } = this.props.location;
    return pathname === "/pos/specialorder" || pathname.startsWith("/pos/specialorder/");
  };

  isGuestCapablePath = () => {
    const pathname = this.props.location.pathname.replace(/\/+$/, "");
    return GUEST_CAPABLE_PATHS.includes(pathname);
  };

  // A guest-capable page renders standalone (no staff topbar/sidebar) while
  // there is no live session yet — it is about to sign in as guest — and for
  // the whole of a session it started as guest. A staff session on the same
  // path does not match either condition and keeps the normal shell.
  rendersGuestStandalone = () =>
    this.isGuestCapablePath() &&
    (!hasLiveSession() || localStorage.getItem(POS_GUEST_SESSION_KEY) === "1");

  onWrapperClick = () => {
    if (!this.menuClick) {
      this.setState({ mobileMenuActive: false });
    }
    this.menuClick = false;
  };

  onToggleMenu = (e) => {
    this.menuClick = true;

    if (window.innerWidth > 1024) {
      this.setState((prev) => ({ staticMenuInactive: !prev.staticMenuInactive }));
    } else {
      this.setState((prev) => ({ mobileMenuActive: !prev.mobileMenuActive }));
    }

    e.preventDefault();
  };

  onSidebarClick = () => {
    this.menuClick = true;
  };

  handleSelectOrderType = (type) => {
    const { pathname } = this.props.location;
    const isOnOrderScreen = pathname === "/pos/" || pathname === "/pos";

    // Only a no-op when we're already on the order screen showing this same
    // type — from any other page (e.g. Captain Dashboard), the type picked
    // still needs to navigate to the order screen even if it happens to
    // match the last-remembered activeOrderType.
    if (isOnOrderScreen && type === this.state.activeOrderType) return;

    // Remembered so a later manual refresh comes back up on the same type —
    // no reload happens here, RestaurantOrder clears its own state in
    // response to the activeOrderType prop change (see its componentDidUpdate).
    localStorage.setItem(ORDER_TYPE_STORAGE_KEY, type);
    this.setState({ activeOrderType: type });

    if (!isOnOrderScreen) {
      this.props.history.push("/pos/");
    }
  };

  render() {
    if (this.props.loading) {
      return <div className="page-loader"></div>;
    }

    // Customer flow — never gated by staff isAuthenticated (that flag
    // defaults to a non-null placeholder token until authCheckState says
    // otherwise, which componentDidMount now deliberately skips for this
    // path — see there for why). LocationGate checks the customer is
    // actually at the restaurant; QrGuestGate then bootstraps the shared
    // guest identity before the route itself mounts. Rendered standalone —
    // no staff topbar/sidebar/footer around a customer's own device.
    if (this.isQrOrderPath()) {
      return (
        <LocationGate>
          <QrGuestGate>
            {this.renderRoutes()}
          </QrGuestGate>
        </LocationGate>
      );
    }

    // Special Order — future-dated remote ordering, so unlike the QR flow
    // there's no on-site LocationGate and no shared bootstrapped identity;
    // SpecialOrderDetails.js logs itself in as the '0000' guest account on
    // mount. Just needs to skip the staff isAuthenticated redirect below so
    // it gets a chance to mount and do that.
    if (this.isSpecialOrderPath()) {
      return this.renderRoutes();
    }

    // Order List / Production Plan — sign themselves in as the guest account
    // when nobody is logged in (see GUEST_CAPABLE_PATHS). Standalone like
    // Special Order, so a guest never gets the staff sidebar; a staff session
    // skips this and falls through to the normal shell below.
    if (this.rendersGuestStandalone()) {
      return this.renderRoutes();
    }

    // The guest account gets the special order page and nothing else.
    if (IS_GUEST_SESSION()) {
      return <Redirect to={GUEST_HOME_PATH} />;
    }

    if (!this.props.isAuthenticated) {
      // Any /pos/* page without auth that isn't the QR flow is staff-facing, so
      // it goes to the login form — not to "/", which is the customer home page.
      return <Redirect to={LOGIN_PATH} />;
    }

    return this.renderShell();
  }

  // Just the route table + top-level error banner — shared by the staff
  // shell (wrapped in topbar/sidebar/footer, below) and the standalone QR
  // customer flow (rendered as-is, no staff chrome).
  renderRoutes() {
    return (
      <>
        {this.props.error && (
          <Messages type="error" message={this.props.error} />
        )}

        <Switch>
          <Route path="/pos/dashboard" exact component={Dashboard} />
          <Route path="/pos/orderlist" exact component={OrderList} />
          <Route path="/pos/reports" exact component={Reports} />
          <Route path="/pos/productionplanreport" exact component={ProductionPlanReport} />
          <Route path="/pos/kotdashboard" exact component={KOTDashboard} />
          <Route path="/pos/tablereservationlist" exact component={TableReservationList} />
          <Route path="/pos/add-tablereservation/:type/:id" exact component={TableReservation} />
          <Route path="/pos/captaindashboard" exact component={CaptainDashboard} />
          <Route path="/pos/printjobs" exact component={PrintJobs} />
          <Route path="/pos/pettycash" exact component={PettyCash} />
          <Route path="/pos/log-out" exact component={Logout} />
          <Route path="/pos/packingdashboard" exact component={PackingDashboard} />
          <Route path="/pos/waiter" exact component={Waiter} />
          <Route path="/pos/qrorder/:tableid?/:tableNo?" exact component={QrOrderlist} />
          <Route path="/pos/qrorder/details" exact component={QrOrderDetails} />
          <Route path="/pos/qrorder/details/:tableId/:tableNo/:requestId?" exact component={QrOrderDetails} />
          {/* Both spellings reach the same page. "/pos/specialorder/" is what the
              user master's "Special Order" default-page option stores (see
              DEFAULT_PAGE_OPTIONS in AddUser.js), so without this route a user
              configured that way fell through to the Redirect at the foot of this
              Switch and landed on the staff order screen instead. Non-strict
              matching means this covers the trailing slash too. */}
          <Route path="/pos/specialorder" exact component={SpecialOrderDetails} />
          <Route path="/pos/specialorder/details" exact component={SpecialOrderDetails} />
          <Route path="/pos/soldout" exact component={SoldOut} />
          <Route path="/pos/signalrtest" exact component={SignalRTest} />
          {/* <Route path="/pos/qrorder" exact component={QrOrder} /> */}
          {/* <Route path="/pos/onlineconfig" exact component={OnlineConfig} />
          <Route path="/pos/dayclose" exact component={DayClose} /> */}
          <Route
            path="/pos/order/:requestid"
            exact
            render={(routeProps) => (
              <RestaurantOrder {...routeProps} activeOrderType={this.state.activeOrderType} />
            )}
          />
          <Route
            path="/pos/"
            exact
            render={(routeProps) => (
              <RestaurantOrder {...routeProps} activeOrderType={this.state.activeOrderType} />
            )}
          />

          <Redirect to="/pos/" />
        </Switch>
      </>
    );
  }

  renderShell() {
    const { pathname } = this.props.location;
    const isOnOrderScreen = pathname === "/pos/" || pathname === "/pos";

    return (
      <div
        className={`pos-wrapper${this.state.mobileMenuActive ? ' pos-mobile-sidebar-active' : ''}`}
        onClick={this.onWrapperClick}
      >
        <POSTopbar
          onToggleMenu={this.onToggleMenu}
          userDetail={this.props.userDetail}
        />

        <div className="pos-body">
          <div
            className={`pos-sidebar-container${this.state.staticMenuInactive ? ' collapsed' : ''}`}
            onClick={this.onSidebarClick}
          >
            <POSSidebar
              collapsed={this.state.staticMenuInactive}
              activeOrderType={isOnOrderScreen ? this.state.activeOrderType : null}
              onSelectOrderType={this.handleSelectOrderType}
            />
          </div>

          <div className="pos-main">
            {this.renderRoutes()}
          </div>
        </div>

        <POSFooter />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.token !== null,
  userDetail: state.auth.userDetail,
  loading: state.auth.loading,
  error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
  onTryAuthSignUp: () => dispatch(actions.authCheckState()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(POSApp));